import { Box } from "@bcc-ui/ui-components";
import classNames from "classnames";
import { Field } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";

import Info from "components/icons/Info";
import style from "components/tenants/add-tenant/add-tenant.scss";
import Tooltip from "components/tooltip/Tooltip";
import defaultColor from "styles/colors/default-color.scss";
import form from "styles/form.scss";

interface AutomaticDeletionData {
    selectedContractType: string;
    handleChange: (value: boolean) => void;
    theme: typeof defaultColor;
    isAutomaticDeletionEnabled: boolean;
    collectValue: (value: boolean) => void;
    value: boolean;
}

export const AutomaticDeletion = (automaticDeletionData: AutomaticDeletionData) => {
    const { t } = useTranslation();
    const [checked, setChecked] = React.useState(automaticDeletionData.isAutomaticDeletionEnabled);

    return (
        <div className={classNames(form.formFields, style.defaultValueCheckbox)}>
            <label htmlFor="automaticDeletion" className={classNames(form.label)}>
                {t("Common.automaticDeletion")}
            </label>
            <Box verticalAlignment="Center">
                <label className={classNames(form.container)}>
                    <Field
                        type="checkbox"
                        id="automaticDeletion"
                        className={classNames(form.input)}
                        checked={automaticDeletionData.value && checked}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setChecked(e.target.checked);
                            automaticDeletionData.collectValue(e.target.checked);
                            automaticDeletionData.handleChange(e.target.checked);
                        }}
                    />
                    <span className={form.checkmark} />
                </label>
                <Tooltip
                    content={<div className={style.tooltipOpen}>{t("Common.automaticDeletionToolTip")}</div>}
                    placement={"top"}
                >
                    <div>
                        <Info
                            borderColor={automaticDeletionData.theme.contentBackgroundColor}
                            color={automaticDeletionData.theme.iconFillColor}
                        />
                    </div>
                </Tooltip>
            </Box>
        </div>
    );
};
